import React from 'react';
import styled from 'styled-components/macro';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import { white, brandLighter, grey5, error, grey70 } from 'variables/colors';
import { borderRadius, boxShadow } from 'variables/general';
import { FlexCenterVertical } from 'styles/flexbox';
import { index10 } from 'variables/z-index';
import { fontWeightSemiBold } from 'variables/font';

const Component = styled.div`
  position: absolute;
  top: ${({ top }) => top};
  left: ${({ statusDropdownPosition }) =>
    statusDropdownPosition >= 0 ? '620px' : '-1.5em'};
  z-index: ${index10};
  width: 12em;
  padding: 0.75em 0;
  color: ${grey70};
  background-color: ${white};
  border-radius: ${borderRadius};
  box-shadow: ${boxShadow};
`;

const MenuItem = styled(FlexCenterVertical)`
  padding: 1em 0.75em;
  font-weight: ${fontWeightSemiBold};
  cursor: pointer;

  &:hover {
    background-color: ${grey5};
  }
`;

const ColorSquare = styled.div`
  width: 1em;
  height: 1em;
  margin-right: 0.75em;
  background-color: ${({ color }) => color};
  border-radius: 0.25em;
`;

const MenuLabel = styled.div``;

const statusOptions = [
  { value: 'Draft', color: '#fdcc86' },
  { value: 'Confirmed', color: brandLighter },
  { value: 'Completed', color: '#81e196' },
  { value: 'Cancelled', color: '#ffb3ba' },
  { value: 'Late Cancelled', color: error },
];

const StatusDropdown = ({
  handleClickAway,
  rowSelected,
  handleStatusChange,
  dataCount,
}) => {
  const window = document.querySelector('.MuiDataGrid-window');
  const container = document.querySelector('.MuiDataGrid-dataContainer');
  const { scrollTop, clientHeight } = window;

  const statusDropdownPosition = rowSelected && rowSelected.target.offsetTop;
  const rowIndex =
    rowSelected &&
    rowSelected.target.parentNode.parentNode.getAttribute('data-rowindex');
  const isLastFewRows = dataCount - rowIndex < 5;

  const condition =
    container.clientHeight - (clientHeight + scrollTop) < 52 * 4;

  const top = `${363 + statusDropdownPosition - scrollTop}px`;

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Component statusDropdownPosition={statusDropdownPosition} top={top}>
        {statusOptions.map(({ value, color }) => (
          <MenuItem onClick={() => handleStatusChange(value)}>
            <ColorSquare color={color} />
            <MenuLabel>{value}</MenuLabel>
          </MenuItem>
        ))}
      </Component>
    </ClickAwayListener>
  );
};
export default StatusDropdown;
